<script>
export default {
  methods: {
    async getTotalOrders(userId, query = { fields: '', limit: 1 }) {
      return app
        .callApi({
          action: 'orders',
          version: 1,
          query: {
            ...query,
            userId,
          },
        })
        .then(response => response?.total)
    },

    async getEstablishmentTotalOrders({
      userId,
      establishmentId: companyId,
      success,
      error,
      complete,
    }) {
      try {
        const { total } = await app.callApi({
          action: 'orders',
          version: 1,
          params: {
            userId,
            companyId,
            fields: '',
          },
        })

        if (typeof success === 'function') return success(total)
      } catch (e) {
        console.error(e)

        if (typeof error === 'function') return error(e)
      } finally {
        if (typeof complete === 'function') return complete()
      }
    },
  },
}
</script>
